import { BINDINGS_BASE } from 'shared/domain/document/documentBinder';
import { DocumentParentBond } from 'shared/domain/document/documentModel';
import { SyncStatus } from 'shared/domain/entitySyncStatus/syncStatus';
import { DocumentInDto } from 'shared/dtos/in/document';
import { DocumentTypes } from 'shared/types/document';
import { UploadStatus, isUploadStatusSuccess } from 'shared/types/uploadStatus';
import { DocumentInsertEntity } from './entity';

export function inDtoToDocumentInsertEntity(
  documentInDto: DocumentInDto,
  parentEntityObject: DocumentParentBond
): DocumentInsertEntity {
  const drawings = documentInDto.drawings ?? [];
  const isDrawn = drawings.length > 0;
  const drawingSyncStatus = resolveDrawingSyncStatus(drawings);

  const fileType = documentInDto.fileType || 'FILE';
  const data = {
    bucketName: documentInDto.bucketName ?? '',
    documentType: documentInDto.documentType ?? DocumentTypes.file,
    extension: documentInDto.extension ?? '',
    isDrawn,
    key: documentInDto.key ?? '',
    name: documentInDto.name ?? '',
    thumbnailKey: documentInDto.thumbnailKey ?? '',
    type: fileType,
    uploadStatus: documentInDto.uploadStatus ?? UploadStatus.unknown,
    url: documentInDto.url ?? '',
  };

  return {
    ...BINDINGS_BASE,
    ...parentEntityObject,
    ...documentInDto,
    isExportAllowed: documentInDto.isExportAllowed,
    drawings,
    data,
    syncStatus: SyncStatus.SUCCESS,
    drawingSyncStatus,
  } as DocumentInsertEntity;
}

function resolveDrawingSyncStatus(
  drawings: Array<{ mergedUploadStatus?: UploadStatus | string }>
): SyncStatus {
  if (!drawings.length) return SyncStatus.SUCCESS;
  const merged = drawings[drawings.length - 1]?.mergedUploadStatus;
  if (isUploadStatusSuccess(merged as UploadStatus)) return SyncStatus.SUCCESS;
  if (merged === UploadStatus.failed || merged === 'FAILED' || merged === 'FAIL') return SyncStatus.FAIL;
  if (merged === 'PENDING' || merged === UploadStatus.unknown) return SyncStatus.PENDING;
  return SyncStatus.SUCCESS;
}
